import type { GambleStep } from "@slot/game-shell";

export const step01Lose: GambleStep = {
  outcome: "lose",
  serverChosenValue: "black",
  terminatesFlow: true,
  // base post-bet balance 100000 + newWin 0 (stake lost)
  balanceAmountMinor: "100000",
};
